import React from "react";
import { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { useNavigate, Link, useParams } from "react-router-dom";
import CurrencyFormat from 'react-currency-format';
import jwt_decode from "jwt-decode";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const FormCetak = React.forwardRef((props, ref) => {
  const navigate = useNavigate();
  // const [idDebitur, setIdDebitur] = useState(null);
  // const { idDebitur } = props;
  const [namaLengkapUser, setNamaLengkapUser] = useState("");
  const [cabang, setCabang] = useState("");
  const [role, setRole] = useState("");
  const [token, setToken] = useState("");
  const [expire, setExpire] = useState(""); 
  const [pinjaman, setPinjaman] = useState([]);
  const [dukcapil, setDukcapil] = useState("SESUAI");
  const [tanggal, setTanggal] = useState("");
  const [enterHeader, setEnterHeader] = useState("");
  const [enterKeterangan, setEnterKeterangan] = useState("");



  useEffect(() => {
    refreshToken();
  },[]);

  useEffect(() => {
    // Set idDebitur ketika props.idDebitur berubah
    if (props.namaLengkapUser) {
      // setIdDebitur(props.idDebitur);
      setNamaLengkapUser(props.namaLengkapUser)
      
    }
  }, [props.namaLengkapUser]);

  useEffect(() => {
    // Set idDebitur ketika props.idDebitur berubah
    if (props.cabang) {
      setCabang(props.cabang)
    }
  }, [props.cabang]);

  useEffect(() => {
    // Set idDebitur ketika props.idDebitur berubah
    if (props.idDebitur) {
      
      getNasabahByid(props.idDebitur)
    }
  }, [props.idDebitur]);

  useEffect(() => {
    // Set idDebitur ketika props.idDebitur berubah
    if (props.dukcapil) {
      // setIdDebitur(props.idDebitur);
      setDukcapil(props.dukcapil)
    }
  }, [props.dukcapil]);

  useEffect(() => {
    // Set idDebitur ketika props.idDebitur berubah
    if (props.tanggal) {
      setTanggal(props.tanggal)
    }
  }, [props.tanggal]);
  
  useEffect(() => {
    // Set idDebitur ketika props.idDebitur berubah
    if (props.enterHeader) {
      // setIdDebitur(props.idDebitur);
      setEnterHeader(props.enterHeader)
    }
  }, [props.enterHeader]);

  useEffect(() => {
    // Set idDebitur ketika props.idDebitur berubah
    if (props.enterKeterangan) {
      // setIdDebitur(props.idDebitur);
      setEnterKeterangan(props.enterKeterangan)
    }
  }, [props.enterKeterangan]);

  // console.log('CEK: ',idDebitur);

  const axiosJWT = axios.create();
axiosJWT.interceptors.request.use(async(config) => {
  const curretDate = new Date();
  if(expire * 1000 < curretDate.getTime()){
      const response = await axios.get(`${process.env.REACT_APP_MASTER_URL}/token`);
      config.headers.Authorization = `Bearer ${response.data.accessToken}`;
      setToken(response.data.accessToken);
      const decoded = jwt_decode(response.data.accessToken);
      setRole(decoded.role);
      // console.log("ini jwt: ",role);
      setExpire(decoded.exp);
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

function toRoman(number) {
  const romanNumeralMap = {
      M: 1000,
      CM: 900,
      D: 500,
      CD: 400,
      C: 100,
      XC: 90,
      L: 50,
      XL: 40,
      X: 10,
      IX: 9,
      V: 5,
      IV: 4,
      I: 1
  };
  let result = '';

  for (let key in romanNumeralMap) {
      while (number >= romanNumeralMap[key]) {
          result += key;
          number -= romanNumeralMap[key];
      }
  }

  return result;
}

const refreshToken = async() => {
try {
    const response = await axiosJWT.get(`${process.env.REACT_APP_MASTER_URL}/token`);
    setToken(response.data.accessToken);
    const decoded = jwt_decode(response.data.accessToken);
    // console.log("ini decode: ",decoded);
    // setUsername(decoded.username);
    // setEmail(decoded.email);
    setRole(decoded.role);
    setExpire(decoded.exp);

} catch (error) {
  if(error.response){
    toast.warning("Silahkan Login!");
    navigate("/login");
  }
}
}

  const getNasabahByid = async (idDebitur) =>{
    const response = await axiosJWT.get(`${process.env.REACT_APP_MASTER_URL}/print/${idDebitur}`,{
      headers:{
          Authorization:`Bearer ${token}`
      }
  })
    setPinjaman(response.data);
    // console.log('DATA PRINT: ', response.data);

  }

  function capitalizeEachWord(str) {
    // Pisahkan string menjadi array kata
    let words = str.split(' ');
  
    // Loop melalui setiap kata dan ubah menjadi capitalize
    for (let i = 0; i < words.length; i++) {
      words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase();
    }
  
    // Gabungkan kembali array kata menjadi string
    return words.join(' ');
  }  


  return (
    <div className="preview" ref={ref}>
      <style>
        {`
          @media print {
            body {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }

            .page-break {
              page-break-before: always;
            }

            .bottom{
              position: relative;
              width: 80%;
              z-index: 1;
              margin-left: 50px;
            }

            .kabid{
              position: relative;
              width: 80%;
              z-index: 1;
              margin-left: 150px;
            }

            .petugas{
              position: relative;
              width: 80%;
              z-index: 1;
              margin-right: 100px;
            }
  
            table {
              border-collapse: collapse;
              position: relative;
              float: right;
              width: 90%;
              z-index: 1;
              margin: 20px;
              margin-top: 0px;
            }
  
            th.main, td.main {
              border: 2px solid black;
              padding: 2px;
              font-size: 11px;
            }
  
            th, td {
              border: 1px solid black;
              padding: 4px;
              font-size: 11px;
            }
  
            .footer {
              position: fixed;
              bottom: 5%;
              width: 90%;
              padding: 30px;
              background-color: white;
            }
  
            .footer img {
              width: 100%;
              max-height: 100px;
            }
  
            .roman-numeral {
              float: left;
              font-weight: bold;
              margin-right: 10px;
            }
          }
        `}
      </style>
          
      <div className="preview-content" style={{marginTop: `${enterHeader}em`}}>
        <div className="d-flex justify-content-between mt-2" style={{ fontSize: 14 }}>
          <div style={{ flex: 1, textAlign: 'center' }}>
            <b>MEMO ANALISA SLIK DAN PENGECEKAN KTP</b>
          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th className="main" style={{ textAlign: 'center' }}>
                MEMO INTERN & DATA KTP
              </th>
            </tr>
          </thead>
        </table>
      
      {pinjaman &&
              pinjaman.map((item, indexT) => (
        <div >
        
        <table style={{marginLeft: '45px', float:"left"}}>
          <thead>
            <tr>
            <th className="main" style={{ textAlign: 'center', border:'none', width:'5px' }}>
                <b>{toRoman(indexT+1)}.</b>
              </th>
              <th  colSpan="2" className="main" style={{ textAlign: 'center' }}>
                DATA KTP
              </th>
              <th className="main" style={{ textAlign: 'center', width: '240px' }}>
                DATA DUKCAPIL
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="main" style={{ textAlign: 'center', border:'none', width:'5px' }}>
              </td>
              <td className="main" style={{ width:'120px'}}>
                Nama Debitur
              </td>
              <td className="main">
                <b>{pinjaman[indexT] && pinjaman[indexT].namaLengkap ? pinjaman[indexT].namaLengkap : null}</b>
              </td>
              <td rowSpan="4" className="main">
                <center><br/>TELAH DILAKUKAN PENGECEKAN DI DUKCAPIL <br/> DENGAN HASIL<br/><a style={{color : "red"}}>{pinjaman[indexT] && pinjaman[indexT].ketDukcapil ? pinjaman[indexT].ketDukcapil : "SESUAI"}</a></center>
              </td>
            </tr>
            <tr>
              <td className="main" style={{ textAlign: 'center', border:'none', width:'5px' }}>
              </td>
              <td className="main" >
                No.KTP
              </td>
              <td className="main">
                <b>{pinjaman[indexT] && pinjaman[indexT].nomorIdentitas ? pinjaman[indexT].nomorIdentitas : null}</b>
              </td>
            </tr>
            <tr>
              <td className="main" style={{ textAlign: 'center', border:'none', width:'5px' }}>
              </td>
              <td className="main" >
                Tempat/Tgl.Lahir  
              </td>
              <td className="main">
                {pinjaman[indexT] && pinjaman[indexT].tempatLahir ? `${pinjaman[indexT].tempatLahir} / ` : ' / '}
                {pinjaman[indexT] && pinjaman[indexT].tanggalLahir ? `${pinjaman[indexT].tanggalLahir.substring(6, 8)}-${pinjaman[indexT].tanggalLahir.substring(4, 6)}-${pinjaman[indexT].tanggalLahir.substring(0, 4)}` : ' '}
                
              </td>
            </tr>
            <tr>
              <td className="main" style={{ textAlign: 'center', border:'none', width:'5px' }}>
              </td>
              <td className="main" >
               Alamat
              </td>
              <td className="main">
               {pinjaman[indexT] && pinjaman[indexT].alamat ? pinjaman[indexT].alamat.substring(0,80) : null}
              </td>
            </tr>
          </tbody>
        </table>
        <a style={{ fontWeight: 'bold', textDecoration: 'underline', fontSize: '11px', marginLeft: '60px' }}>DATA PINJAMAN</a>
        <table>
          <thead>
            <tr>
            <th  style={{ verticalAlign: 'middle',  textAlign: 'center', width: '165px' }}>
                NAMA BANK
              </th>
              <th  style={{ verticalAlign: 'middle',  textAlign: 'center' }}>
                PLAFOND AWAL
              </th>
              <th style={{ verticalAlign: 'middle',  textAlign: 'center' }}>
                BAKI DEBET
              </th>
              <th style={{ verticalAlign: 'middle',  textAlign: 'center' }}>
                COLL
              </th>
              <th style={{ verticalAlign: 'middle',  textAlign: 'center', width: '100px' }}>
                JMN
              </th>
              <th style={{ verticalAlign: 'middle',  textAlign: 'center' }}>
                SK BG
              </th>
              <th style={{ verticalAlign: 'middle',  textAlign: 'center' }}>
                JW
              </th>
              <th style={{ verticalAlign: 'middle',  textAlign: 'center', width: '75px' }}>
                TGL UPDATE SLIK
              </th>
              <th style={{ verticalAlign: 'middle',  textAlign: 'center', width: '130px' }}>
                KET
              </th>
            </tr>
          </thead>
          <tbody>
          {pinjaman[indexT].pinjaman.length === 0 ? (
            <tr>
              <td colSpan="10" style={{ textAlign: "center", fontWeight: "bold",  color: "red" }}>
                ---DATA TIDAK DITEMUKAN---
              </td>
            </tr>
          ) : null}

          
            {pinjaman[indexT] &&
              pinjaman[indexT].pinjaman.map((item, index) => (
                <tr key={index}>
                  <td style={{ verticalAlign: 'middle'}}>{item.namaBank.substring(0,48) || null}.</td>
                  <td style={{ verticalAlign: 'middle' }}>
                    <CurrencyFormat
                      value={item.plafond || '0'}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'Rp.'}
                    />
                  </td>
                  
                  <td style={{ verticalAlign: 'middle' }}>
                    <CurrencyFormat
                      value={item.bakiDebet || '0'}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'Rp.'}
                    />
                  </td>
                  <td style={{ verticalAlign: 'middle',  textAlign: 'center' }}><center><b>{item.coll || '0'}<br/>{item.jmlHariTunggakan || '0'}</b></center></td>
                  <td style={{ verticalAlign: 'middle',  textAlign: 'center'}}>{capitalizeEachWord(item.jaminan.substring(0,45) || null)}.</td>
                  <td style={{ verticalAlign: 'middle',  textAlign: 'center' }}>
                    {item.sukuBunga || null}%
                  </td>
                  <td style={{ verticalAlign: 'middle',  textAlign: 'center' }}>{item.jangkaWaktu || null}</td>
                  <td style={{ verticalAlign: 'middle',  textAlign: 'center' }}>
                    {item.tglUpdateSlik
                      ? `${item.tglUpdateSlik.substring(6, 8)}-${item.tglUpdateSlik.substring(4, 6)}-${item.tglUpdateSlik.substring(0, 4)}`
                      : null}
                  </td>
                  <td style={{ verticalAlign: 'middle'}}>{item.keterangan || null}</td>
                </tr>
                
              ))}
              {pinjaman[indexT] && pinjaman[indexT].totalPlafond  !='0' ? <>
              <tr>
                <td></td>
                <td>
                  {pinjaman[indexT] && pinjaman[indexT].totalPlafond !='0' ?<CurrencyFormat
                        value={pinjaman[indexT].totalPlafond || '0'}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'Rp.'}
                    /> : null }
                </td>
                <td>
                    {pinjaman[indexT] && pinjaman[indexT].totalBakiDebet !='0' ?<CurrencyFormat
                      value={pinjaman[indexT].totalBakiDebet || '0'}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'Rp.'}
                    />  :null}
                  </td>
                <td colSpan={6}></td>
              </tr>
              </>:null}
          </tbody>
        </table>
        </div>
        ))}

        <div className="bottom mt-10" style={{marginTop: '10em'}}>
          <a style={{ fontSize: '12px', display: 'block' }}><u><b>Keterangan</b></u></a>
          <a style={{ fontSize: '11px', display: 'block' }}>SETELAH DILAKUKAN PENGECEKAN SLIK, DEBITUR ({pinjaman[0] && pinjaman[0].pinjaman.length === 0 ? (<>TIDAK MEMILIKI/<s>MEMILIKI</s></>) : (<><s>TIDAK MEMILIKI</s>/MEMILIKI </>)}) PINJAMAN</a>
          <a style={{ fontSize: '11px', display: 'block' }}>DI BANK UMUM / BPR / SYARIAH ( DATA SLIK TERLAMPIR )</a>
          <a style={{ fontSize: '11px', display: 'block' }}>HASIL PENGECEKAN DI DUKCAPIL (TERLAMPIR)</a>
          <div>
                <a style={{ fontSize: '12px', marginLeft: '50%' }}>Mengetahui,<a style={{ fontSize: '11px',  marginLeft: '55px'}}>Brondong, {tanggal}</a></a>
          </div>
        </div>
 
        <div className="kabid">
          <div className="mb-5">
            <a  style={{ fontSize: '11px', }}>Kabid. Operasional</a>
            <a style={{ fontSize: '11px',  marginLeft: '250px'}}>Petugas Slik</a>
          </div>
          <br/>
          <div>
            <a  style={{ fontSize: '11px' }}>{cabang === 'pusat' ? "Elly Trisnani Rohmawati,S.Kom" : cabang === 'gresik' ? "Anissatul Khamidah,S.Pd" : "Dewi Istiani,S.Sos"}</a>
            <a  style={{ fontSize: '11px', marginLeft: '190px' }}>{namaLengkapUser}</a>
          </div>
        </div>
      </div>
    </div>
  );
});

export default FormCetak;
